import axios from 'axios'
var jwt = require('jwt-simple')

// var ant = ""
var authorization = {
  async encodeDataNew (data) {
    try {
      const response = await axios.get(process.env.VUE_APP_API_DOMAIN +'service/timestamp/')
      data.TimeStamp = response.data.Message.TimeStamp
      const randomStr1 = await this.random(32)
      const encodedData = jwt.encode(data, 'bill', false, 'HS256')
      const encoded = encodedData.split('.')
      encoded[1] = encoded[1] + randomStr1
      const encodedBody = encoded[2] + '.' + encoded[0] + '.' + encoded[1]
      return encodedBody
    } catch (err) {
      return data
    }
  },
  random (len) {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    let counter = 0
    while (counter < len) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
      counter += 1
    }
    return result
  }
}

export default authorization
